import type { AiChatMessageAgentIterationStep, LiveContentStatus, TID } from "@/lib/client/generated/TypeDefinitions.ts"

export interface AgentIterationDetailsArgs {
  chatMessageId: TID,
  steps: AiChatMessageAgentIterationStep[]
  resultStep?: AiChatMessageAgentIterationStep | null
}

export function useAgentIterationDetailsModel(args: AgentIterationDetailsArgs) {
  const { steps, resultStep } = args

  const hasSeparatedResultStep = !!resultStep && steps.length > 0

  const getGenericStatusText = (status: LiveContentStatus | null): string => {
    if (status === "InProgress") return "The script is running"
    if (status === "Succeeded") return "The script completed successfully"
    if (status === "Failed") return "The script has failed"
    if (status === "Cancelled") return "The script has been cancelled"
    return "Script output"
  }

  return {
    hasSeparatedResultStep,
    getGenericStatusText,
  }
}
